import * as amplitude from '@amplitude/analytics-browser';
import { buildDefaultAmplitudeProperties } from './buildDefaultAmplitudeProperties';

/**
 * Cria o enrichment plugin que injeta as propriedades default em
 * `event_properties` de TODOS os eventos enviados ao Amplitude.
 *
 * As propriedades default são espalhadas por último, tendo precedência sobre as
 * passadas manualmente no payload. Isso garante a fonte correta e centralizada —
 * por exemplo, corrige `partner_id`/`partner_name`, que historicamente vinham de
 * `prescriberConfiguration` em vez de `prescription.Origem`.
 *
 * A leitura do store acontece de forma lazy dentro do `execute` (a cada evento),
 * o que também evita ciclos de import entre o módulo do Amplitude e a store.
 *
 * @returns Plugin de enrichment pronto para registro via `client.add`
 */
export function defaultEventPropertiesPlugin(): amplitude.Types.EnrichmentPlugin {
  return {
    name: 'default-event-properties',
    type: 'enrichment',
    async execute(event) {
      event.event_properties = {
        ...(event.event_properties ?? {}),
        ...buildDefaultAmplitudeProperties(),
      };
      return event;
    },
  };
}
